import {
  createContext,
  ReactElement,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import {useGlobalState} from '../hooks/useGlobalState.client';

interface ViewKeyContextProps {
  viewKey: string;
}

export const ViewKeyContext = createContext<ViewKeyContextProps>({
  viewKey: null,
});

interface ViewKeyProviderProps extends ViewKeyContextProps {
  children: ReactNode | ReactNode[];
}

export function ViewKeyProvider({
  children,
  viewKey,
}: ViewKeyProviderProps): ReactElement {
  // Keep the global viewKey in sync with the passed prop
  const [, setViewKey] = useGlobalState('viewKey');
  useEffect(() => {
    setViewKey(viewKey);
  }, [setViewKey, viewKey]);

  const value = useMemo(() => ({viewKey}), [viewKey]);

  return (
    <ViewKeyContext.Provider value={value}>{children}</ViewKeyContext.Provider>
  );
}

export function useViewKey(): ViewKeyContextProps {
  const context = useContext(ViewKeyContext);
  if (context === undefined) {
    throw new Error('useViewKey must be used within ViewKeyContext children');
  }

  return context;
}
